import { IconInfoCircle, IconAlertCircle, IconLoader2, IconCircleCheck } from '@tabler/icons-react';

export enum AlertVariant {
  Info = 'info',
  Warning = 'warning',
  Loading = 'loading',
  Success = 'success'
}

interface StatusAlertProps {
  type: AlertVariant;
  heading?: string;
  subHeading?: string;
}

export const StatusAlert: React.FC<StatusAlertProps> = ({ type = AlertVariant.Info, heading, subHeading }) => {
  const styles = {
    [AlertVariant.Info]: {
      bg: 'bg-blue-50',
      icon: <IconInfoCircle className="size-5 shrink-0 text-blue-500" />,
      headingColor: 'text-blue-800',
      subHeadingColor: 'text-blue-600'
    },
    [AlertVariant.Warning]: {
      bg: 'bg-amber-50',
      icon: <IconAlertCircle className="size-5 shrink-0 text-amber-500" />,
      headingColor: 'text-amber-800',
      subHeadingColor: 'text-amber-600'
    },
    [AlertVariant.Loading]: {
      bg: 'bg-slate-50',
      icon: <IconLoader2 className="size-5 shrink-0 animate-spin text-slate-500" />,
      headingColor: 'text-slate-800',
      subHeadingColor: 'text-slate-600'
    },
    [AlertVariant.Success]: {
      bg: 'bg-emerald-50',
      icon: <IconCircleCheck className="size-5 shrink-0 text-emerald-500" />,
      headingColor: 'text-emerald-800',
      subHeadingColor: 'text-emerald-600'
    }
  };

  const currentStyle = styles[type];

  return (
    <div className={`flex items-center gap-2 rounded-lg ${currentStyle.bg} p-2`}>
      {currentStyle.icon}
      <div>
        {heading && <p className={`text-xs font-medium ${currentStyle.headingColor}`}>{heading}</p>}
        {subHeading && <p className={`text-xs ${currentStyle.subHeadingColor}`}>{subHeading}</p>}
      </div>
    </div>
  );
};
